import type { ComponentType } from "react"
import type { Location as RouterLocation } from "react-router-dom"

export const lazyRetry = function (
	componentImport: () => Promise<{ default: ComponentType<any> }>,
	name: string
): Promise<{ default: ComponentType<any> }> {
	return new Promise((resolve, reject) => {
		// check if the window has already been refreshed
		const hasRefreshed = JSON.parse(window.sessionStorage.getItem(`retry-${name}-refreshed`) || "false")
		// try to import the component
		componentImport()
			.then((component) => {
				window.sessionStorage.setItem(`retry-${name}-refreshed`, "false") // success so reset the refresh
				resolve(component)
			})
			.catch((error: Error) => {
				if (!hasRefreshed) {
					// not been refreshed yet
					window.sessionStorage.setItem(`retry-${name}-refreshed`, "true") // we are now going to refresh
					return window.location.reload() // refresh the page
				}
				reject(error) // Default error behaviour as already tried refresh
			})
	})
}

/** Returns `?r={encoded URI for the redirection path}` or an empty string based on provided pathname. */
export function getRedirectionSearchParam(location: Location | RouterLocation) {
	const value = getRedirectionSearchParamValue(location)

	if (!value) {
		return ""
	}
	return `?r=${value}`
}

function getRedirectionSearchParamValue(location: Location | RouterLocation) {
	if (!location.pathname || location.pathname.length < 1) {
		return ""
	}
	return encodeURIComponent(location.pathname + location.search + location.hash)
}
